import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TimerFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M18.6807 5.89848C18.2986 5.53895 17.8876 5.20991 17.4514 4.91523L18.584 4.1602C18.9286 3.93044 19.3943 4.02356 19.624 4.36821C19.8538 4.71285 19.7607 5.17848 19.416 5.40825L18.6807 5.89848ZM5.31933 5.89848C5.70135 5.53895 6.11239 5.20991 6.54856 4.91523L5.41602 4.1602L5.34961 4.12114C5.01367 3.9435 4.59133 4.04518 4.37598 4.36821C4.16057 4.69132 4.22908 5.12061 4.52246 5.36235L4.58398 5.40825L5.31933 5.89848Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 2.75V3.27842C11.4975 3.25959 11.7476 3.25 12 3.25C12.2524 3.25 12.5025 3.25959 12.75 3.27842V2.75H14.5C14.9142 2.75 15.25 2.41421 15.25 2C15.25 1.58579 14.9142 1.25 14.5 1.25H9.5C9.08579 1.25 8.75 1.58579 8.75 2C8.75 2.41421 9.08579 2.75 9.5 2.75H11.25Z"
				fill="currentColor"
			/>
			<path
				d="M12 3.25C11.7476 3.25 11.4975 3.25959 11.25 3.27842C9.51678 3.41027 7.91023 3.99528 6.54856 4.91523C6.11239 5.20991 5.70135 5.53895 5.31933 5.89848C3.42981 7.67669 2.25 10.2006 2.25 13C2.25 18.3848 6.61522 22.75 12 22.75C17.3848 22.75 21.75 18.3848 21.75 13C21.75 10.2006 20.5702 7.67669 18.6807 5.89848C18.2986 5.53895 17.8876 5.20991 17.4514 4.91523C16.0898 3.99528 14.4832 3.41027 12.75 3.27842C12.5025 3.25959 12.2524 3.25 12 3.25ZM13.2928 11.7427C14.0069 12.4569 14.0075 13.6146 13.2934 14.3288C12.5793 15.043 11.4209 15.043 10.7067 14.3288C9.99272 13.6146 9.99328 12.4568 10.7074 11.7427C10.8686 11.5815 11.053 11.4576 11.2495 11.3691L11.2502 8.00003C11.2502 7.58582 11.5859 7.25012 12.0001 7.25011C12.4143 7.25011 12.75 7.58581 12.75 8.00003L12.7493 11.3691C12.9462 11.4576 13.1312 11.5812 13.2928 11.7427Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TimerFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TimerFilledIcon;
